var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('a-spin',[_c('a-icon',{class:{ 'is-medium': _vm.isMedium },attrs:{"slot":"indicator","type":"loading","spin":""},slot:"indicator"})],1),_c('p',{staticClass:"text-info"},[_vm._v(_vm._s(_vm.textInfo))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }